import { render, staticRenderFns } from "./RevenueChartTwo.vue?vue&type=template&id=0968d56e&"
import script from "./RevenueChartTwo.vue?vue&type=script&lang=js&"
export * from "./RevenueChartTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports